module.exports = __webpack_public_path__ + "img/1a_Dashboard.3f290036.png";